<ng-container *ngIf="scoreboard.started">
    <span class="player-name" *ngFor="let player of players; let i = index">{{ i + 1 }}. {{ player.name }}</span>
</ng-container>
